<template>
  <div :class="['btn-wraper', {'offline_offsite_wraper': offline_offsite}]" :style="{background: btnItem.color, border: btnItem.border}" v-show="show">
    <p v-if="offline_offsite" class="text-link">
      <span @click="showSite">{{offline_offsite.title}}</span>
    </p>
    <input v-if="third_link" type="button" :style="{color: btnItem.font_color}" :value="third_link.title" @click="goTrans" />
    <input v-else type="button" :style="{color: btnItem.font_color}" :value="btnItem.title" @click="goTrans" />
    <offline-site ref="offlineSite" :config="offline_offsite || {}"></offline-site>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import OfflineSite from "./offline-site";
import { getEnd } from "../../tools/utils";
import { ends, LOGIN_CONFIG } from "../../tools/constant";
export default {
  props: ["btnItem"],
  components: { OfflineSite },
  computed: {
    ...mapState(["_ticket", "_cell", "_uuid"]),
    show() {
      let end = getEnd();
      let d = this.btnItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
    offline_offsite() {
      return this.btnItem["attach-link"];
    },
    third_link() {
      return this.btnItem["third-link"];
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      if (this.offline_offsite.target == "blank") {
        location.href = this.offline_offsite.link;
        return;
      }
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    regSuccess() {
      let params = new URLSearchParams(location.search);
      let ticket =
        this._ticket || params.get("ticket") || params.get("token") || '';
      let cell = (params.get("cell") || this._cell || "").trim();
      let location_country = params.get("location_country");
      if (cell.substr(0, 1) != "+") {
        let code = (LOGIN_CONFIG[location_country] || window.didii18nconfig[location_country]).country_calling_code;
        // @20190704 兼容电话号已传递的情况 55、+55
        if (cell.indexOf(code.substr(1)) == 0) {
          code = "+";
        }
        cell = `${code}${cell}`;
      }
      Fusion.registSuccess(
        {
          cell,
          global_phone: cell,
          ticket,
          token: ticket,
          uid: params.get("uid") || this._uuid + '',
          role: 2
        },
        () => {}
      );
    },
    goTrans() {
      if (this.third_link) {
        let l = this.third_link.link;
        if (this.third_link.is_white) {
          let up = new URLSearchParams(location.search);
          if (ends.inApp) {
            up.set("entryType", 0);
          } else {
            up.set("entryType", 1);
          }
          if (this._ticket) {
            up.set("ticket", this._ticket);
          }
          if (l.indexOf("?") > -1) {
            l = `${l}&${up}`;
          } else {
            l = `${l}?${up}`;
          }
        }
        if (ends.inApp) {
          location.href = l;
        } else {
          window.open(l);
        }
      } else if (this.btnItem.bridge) {
        let bridge = this.btnItem.bridge;
        if (bridge === 'registSuccess') {
          this.regSuccess();
        } else {
          Fusion[this.btnItem.bridge]({});
        }

      } else {
        this.setState({
          _roleTrans: "1",
        });
        this.$router.replace({ name: "home" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-wraper {
  width: 100%;
  height: 1.08rem;
  line-height: 1.08rem;
  border-radius: 0.04rem;
  font-size: 0.36rem;
  font-weight: 500;
  background: #ff7226;
  color: #ffffff;
  text-align: center;
  box-sizing: border-box;
  .text-link {
    position: absolute;
    width: 100%;
    left: 0;
    top: -0.7rem;
    line-height: normal;
    font-size: 0.32rem;
    color: #666666;
  }
  input {
    width: 100%;
    height: 100%;
    background-color: transparent;
    color: #ffffff;
  }
  .offline-office {
    line-height: 1;
  }
}
</style>
